import { useState } from 'react'


const useSort = () => {
  const [orderBy, setOrderBy] = useState('traffic')
  const [orderDirection, setOrderDirection] = useState<'asc' | 'desc' | undefined>('asc')

  const handleOrderBy = (newOrderBy: string) => {
    setOrderBy(newOrderBy)
    if (orderDirection !== 'desc') {
      setOrderDirection('desc')
    }
  }

  const compareLabel = (a, b) => {
    return a.name.localeCompare(b.name)
  }

  // comparing traffic is the same as comparing percentage
  // because percentage is ssid's part of total
  const compareTraffic = (a, b) => {
    return a.total - (b.total)
  }

  const sort = (ssids) => {
    return [...ssids].sort((a, b) => {
      if (orderDirection === 'desc') {
        if (orderBy === 'percentage' || orderBy === 'traffic') {
          return compareTraffic(a, b)
        } else {
          return compareLabel(a, b)
        }
      } else {
        if (orderBy === 'percentage' || orderBy === 'traffic') {
          return compareTraffic(b, a)
        } else {
          return compareLabel(b, a)
        }
      }
    })
  }

  return {
    orderByChange: (newOrderBy: string) => {
      if (newOrderBy === orderBy) {
        setOrderDirection((prev) => (prev === 'desc' ? 'asc' : 'desc'))
      } else {
        handleOrderBy(newOrderBy)
      }
    },
    orderBy,
    orderDirection,
    sort,
  }
}

export default useSort
